export default "__VITE_ASSET__519da751__"